const normalizeString = value => value?.toLowerCase() || '';

export const equals = (string1, string2) =>
  normalizeString(string1) === normalizeString(string2);

export const includes = (string1 = '', string2 = '') =>
  new RegExp(string1, 'i').test(string2);

export const indexOf = (string1, string2, position = 0) =>
  normalizeString(string1)?.indexOf(normalizeString(string2), position);

export const includesAny = (array, value) =>
  array.includes(normalizeString(value));
